import { Link } from 'react-router-dom';
import CTABand from '../components/CTABand.jsx';
import SEO from '../components/SEO.jsx';
import useReveal from '../hooks/useReveal.js';
import { WA_URL } from '../config.js';
import { localBusinessSchema, organizationSchema } from '../data/schemas.js';

export default function About() {
  useReveal();

  const pillars = [
    { n:'01', label:'ההימור', h:'AI עושה את ה-90% המשעמם.', h2:'הראש שלך עושה את ה-10% החשוב.', body:'כל הזמן שבזבזנו על ניירת, סטטוסים, תיעוד, החלטות שנתקעו, נחתך. מה שנשאר זה הצורך לדעת מה לבנות, באיזה סדר, ולמה. את זה אף AI לא יודע לעשות בשבילך.' },
    { n:'02', label:'ההבטחה', h:'סטטוס שבועי בכתב.', h2:'לא 15 הודעות וואטסאפ.', body:'FocusMode זה השם של המצב שלקוחות שלי נכנסים אליו אחרי שאני נכנס לפרויקט. המצב שבו הפרויקט נע, ברור, מתועד, ומעלה את כולם, לא רק את ההנהלה, לרמה הבאה.' },
    { n:'03', label:'הסטנדרט', h:'AI כותב את הקוד.', h2:'אני מחליט מה נבנה.', body:'אני לא מפתח, ואני לא מתיימר להיות. אני מנהל פרויקטים שיודע לשאול את השאלות הנכונות, לקרוא את התשובות, ולהוביל את הפיתוח עד שהוא עובד. האחריות על התוצאה היא שלי, גם בעוד שנה.' },
  ];

  const how = [
    { n:'01', h:'אני לא מתחיל ממערכת.', h2:'אני מתחיל מהמציאות.', body:'בודק איך הארגון עובד היום באמת. לא איך חושבים שהוא עובד. רק אז בונה.' },
    { n:'02', h:'סטטוס שבועי בכתב.', h2:'לא 15 הודעות.', body:'פעם בשבוע אתה יודע איפה הפרויקט עומד. במייל. בכתב. בלי לרדוף אחריי.' },
    { n:'03', h:'בודק כל שינוי לפני שהוא עולה.', h2:'אין הפתעות באוויר.', body:'לא מעלים לאוויר משהו שלא נבדק. כל שינוי עובר בדיקה מולי לפני שהוא מגיע אליכם.' },
    { n:'04', h:'אני לא נעלם.', h2:'אחרי החתימה.', body:'חודש ליווי כלול. אחר כך, או ריטיינר, או "תקרא לי כשצריך". בלי להיעלם.' },
    { n:'05', h:'אומר "לא" כשצריך.', h2:'בשיחה הראשונה.', body:'אם הפרויקט שלך לא מתאים לי, אגיד את זה בשיחה הראשונה. לא בחודש השלישי.' },
  ];

  const notMe = [
    { h:'לא בית תוכנה גדול.', b:'אם הפרויקט שלך דורש 5 מפתחים במקביל, אני לא המתאים.' },
    { h:'לא יועץ ארגוני קלאסי.', b:'לא מטפל ב-HR, ב-feedback של עובדים, או בתרבות ארגונית.' },
    { h:'לא AI guru.', b:'לא מבטיח "פי 10 לידים". מי שמבטיח את זה לא יודע מה הוא מבטיח.' },
    { h:'לא Wix/וורדפרס.', b:'אם זה מה שמתאים לך, תלך לשם. חבל לשלם לי.' },
    { h:'לא 24/7.', b:'שעות עבודה: א\'ה\' 10:00–18:00. emergency רק ל-premium maintenance.' },
  ];

  const numbers = [
    { n:'35', l:'גיל' },
    { n:'12', l:'שנים בדיגיטל' },
    { n:'3', l:'שנים בהובלת פרויקטים' },
    { n:'100%', l:'אני מדבר איתך. לא מנהל לקוח.' },
  ];

  return (
    <main className="about-page">
      <SEO
        title="אודות"
        description="יואב רון. בן 35. 12 שנות ניסיון בדיגיטל. FocusMode לוקחת רעיונות לא מסודרים ופרויקטים מורכבים והופכת אותם למערכות עבודה אמיתיות."
        path="/about"
        schema={[localBusinessSchema, organizationSchema]}
      />

      <section className="ab-hero">
        <div className="wrap">
          <div className="svc-eyebrow"><span className="svc-eyebrow-bar"></span>על FocusMode</div>
          <h1 className="ab-h1">
            לוקח <span className="hl-block tilt-l">רעיונות לא מסודרים</span><br/>
            ופרויקטים מורכבים.<br/>
            הופך אותם ל<span className="hl-block tilt-r">מערכות עבודה אמיתיות</span>.
          </h1>
          <p className="ab-lede">
            אני יואב רון. בן 35.<br/>
            גר בקיבוץ גבעת השלושה.<br/>
            התחלתי ב-2015 בתור תקציבאי. ניהלתי קמפיינים. בניתי צוותי דיגיטל.<br/>
            ב-3 השנים האחרונות עברתי למקום שתמיד הייתי בו טוב: לנהל פרויקטים טכנולוגיים מורכבים שצריך להוציא מהקרקע. לעמוד בזמנים. לחבר אנשים, מערכות ואחריות.
          </p>
        </div>
      </section>

      <section className="ab-pillars">
        <div className="wrap">
          <div className="svc-section-head reveal">
            <div className="svc-eyebrow"><span className="svc-eyebrow-bar"></span>3 דברים שאני מתחייב עליהם</div>
            <h2 className="svc-h2">העקרונות.</h2>
          </div>
          <div className="ab-pillars-grid">
            {pillars.map(p => (
              <article key={p.n} className="ab-pillar reveal">
                <div className="ab-pillar-meta">
                  <div className="ab-pillar-n">{p.n}</div>
                  <div className="ab-pillar-label">{p.label}</div>
                </div>
                <h3 className="ab-pillar-h">
                  {p.h}<br/>
                  <span className="ab-pillar-h2">{p.h2}</span>
                </h3>
                <p className="ab-pillar-body">{p.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ab-not">
        <div className="wrap">
          <div className="svc-section-head reveal">
            <div className="svc-eyebrow ab-not-eyebrow"><span className="svc-eyebrow-bar"></span>חשוב לי שתדע</div>
            <h2 className="svc-h2 ab-not-h2">מה <span className="hl-block tilt-l">אני לא</span>.</h2>
            <p className="ab-not-lede">
              לפני שאני אומר מה אני כן.<br/>
              שתי דקות של הקשר. חוסך זמן לשנינו.
            </p>
          </div>
          <div className="ab-not-grid">
            {notMe.map((x, i) => (
              <div key={i} className="ab-not-card reveal">
                <div className="ab-not-mark">×</div>
                <h4 className="ab-not-h">{x.h}</h4>
                <p className="ab-not-b">{x.b}</p>
              </div>
            ))}
          </div>
          <p className="ab-not-foot reveal">
            כל מה שאני כן, בעמודי השירותים.<br/>
            <Link to="/services">לראות את השירותים</Link>
          </p>
        </div>
      </section>

      <section className="ab-how">
        <div className="wrap">
          <div className="svc-section-head reveal">
            <div className="svc-eyebrow"><span className="svc-eyebrow-bar"></span>איך אני עובד</div>
            <h2 className="svc-h2">5 כללים.</h2>
          </div>
          <div className="ab-how-list">
            {how.map(h => (
              <article key={h.n} className="ab-how-row reveal">
                <div className="ab-how-n">{h.n}</div>
                <div className="ab-how-body">
                  <h3 className="ab-how-h">{h.h} <span className="ab-how-h2">{h.h2}</span></h3>
                  <p className="ab-how-b">{h.body}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ab-numbers">
        <div className="wrap">
          <div className="ab-numbers-grid">
            {numbers.map((n, i) => (
              <div key={i} className="ab-num reveal">
                <div className="ab-num-n">{n.n}</div>
                <div className="ab-num-l">{n.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ab-sig">
        <div className="wrap">
          <div className="svc-eyebrow ab-sig-eyebrow reveal"><span className="svc-eyebrow-bar"></span>הקו האחרון</div>
          <p className="ab-sig-body reveal">
            לוקח <span className="hl-block tilt-l">רעיונות לא מסודרים</span><br/>
            ופרויקטים מורכבים.<br/>
            והופך אותם למערכות עבודה<br/>
            <span className="hl-block tilt-r">אמיתיות, יציבות וישימות</span>.
          </p>
        </div>
      </section>

      <CTABand
        title={<>מוכן ל<span className="hl-block tilt-r">שיחה אמיתית</span>?</>}
        body="3 משפטים בוואטסאפ. אני חוזר תוך 48 שעות."
      />
    </main>
  );
}
